// Projects component
"use client";
import React from "react";
import { InfiniteMovingCards } from "@/components/ui/infinite-moving-cards";
import NotifierPic from '../../../public/notifier-pic.PNG'
import MMCPic from '../../../public/MMC-pic.png'
import MMCProject from '../../../public/MMC_project.jpg'
import AutomationProject from '../../../public/wa.jpeg'
import HospitraxProject from '../../../public/hospitrax-pic.PNG'
import NuintroxProject from '../../../public/nuintrox.PNG'
import SchoolProject from '../../../public/school.jpeg'
 function Projects() {
  return (
    <div id="projects" className="h-full py-32 md:py-40  flex flex-col antialiased   items-center justify-center overflow-hidden">
      <div className="heading-glow section-shell">
      <h1 className="text-4xl md:text-6xl section-heading py-10 font-semibold text-center">
      Projects
      </h1>
      </div>
      <InfiniteMovingCards items={projectItems} />
    </div>
  );
}
export default Projects
const projectItems = [
  // {
  //   title: "Forexter",
  //   url:'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575826/project1_qit63s.png',
  //   link: "https://forexter.pk/",
  //   href: "https://forexter.pk/",
  // },
  {
    title: "Cyltrax",
    url:'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575826/project2_nyc8np.png',
    link: "https://cyltrax.com/",
    href: "https://cyltrax.com/",
  },
  {
    title: "Digital Singage",
    // url:'https://res.cloudinary.com/dsvbvqa5m/image/upload/v1764935437/nutrack-web_oj47w4.png',
    url:   MMCPic,
    // link: "https://nf.lineup.pk/",
    // href: "https://nf.lineup.pk/",
  },
  {
    title: "Enterprise Resource Planning (ERP)",
    url:'https://res.cloudinary.com/dcwai4hwc/image/upload/v1731567203/erp_y033b2.png',
    //  link: "https://trade-hub.com.pk/",
    //  href: "https://trade-hub.com.pk/",
  },
  {
    title: "Hedge Play",
    url:'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575826/project4_gaj94x.png',
    link: "https://trade-hub.com.pk/",
    href: "https://trade-hub.com.pk/",
  },
  {
    title: "Hospital Management System (HMS)",
    url: MMCProject
  },
  {
    title: "Hospitrax",
    url:   HospitraxProject,
    link: "https://hospitraxai.com/",
    href: "https://hospitraxai.com/",
  },
  {
    title: "Notifier",
    // url:'https://res.cloudinary.com/dsvbvqa5m/image/upload/v1764935437/nutrack-web_oj47w4.png',
    url:   NotifierPic,
    link: "https://nf.lineup.pk/",
    href: "https://nf.lineup.pk/",
  },
  {
    title: "NuIntroX",
    url:   NuintroxProject,
    link: "https://nuintrox.vercel.app/",
    href: "https://nuintrox.vercel.app/",
  },
  {
    title: "NUREADY (POS)",
    url:'https://res.cloudinary.com/dcwai4hwc/image/upload/v1731498163/1_glbeyc.png',
    //  link: "https://trade-hub.com.pk/",
    //  href: "https://trade-hub.com.pk/",
  },
  {
    title: "Nutrack (HRMS)",
    // url:'https://res.cloudinary.com/dsvbvqa5m/image/upload/v1764935437/nutrack-web_oj47w4.png',
    url:'https://res.cloudinary.com/dsvbvqa5m/image/upload/v1764935587/Screenshot_109_ajbgoe.png',
    link: "https://nutrack.nubitsoft.com/",
    href: "https://nutrack.nubitsoft.com/",
  },
  {
    title: "School Management System",
    url: SchoolProject
  },
  {
    title: "Stock Equity Back Office (SEBO)",
    url:'https://res.cloudinary.com/dcwai4hwc/image/upload/v1731396765/sebo_bdb6pg.jpg',
    //  link: "https://trade-hub.com.pk/",
    //  href: "https://trade-hub.com.pk/",
  },
  {
    title: "Trade Hub",
    url:'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575826/project3_ylvdqd.png',
    link: "https://trade-hub.com.pk/",
    href: "https://trade-hub.com.pk/",
  },
  {
    title: "Whatsapp Automation",
    url: AutomationProject
  },
  // Add more project items as needed
];